import {
  Avatar,
  Box,
  Button,
  Menu,
  MenuItem,
  useMediaQuery,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { viewImage } from "../../utils/viewPDF";

const FONT = "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif";
const INK = "#0F1B2A";
const LINE = "#E4E9EF";

function stringAvatar(name) {
  const parts = name.trim().split(" ");
  if (parts.length === 1) {
    return {
      children: parts[0][0].toUpperCase(),
    };
  } else {
    return {
      children: `${parts[0][0]}${parts[1][0]}`.toUpperCase(),
    };
  }
}

const PartnerNavbar = ({projectId, setProjectId}) => {
  const [user, setUser] = useState();
  const [org, setOrg] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [fileUrl, setFileUrl] = useState("");
  const isMobile = useMediaQuery("(max-width: 750px)");
  const [projects, setProjects] = useState();
  

  useEffect(() => {
    const getUser = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/partner/details`,
          {
            headers: { Authorization: `Bearer ${storedUser.accessToken}` },
          }
        );
        setUser(res.data);
      } catch (error) {
        console.log(error);
        navigate("/");
        localStorage.clear();
      }
    };
    getUser();
  }, []);

//   useEffect(() => {
//     const getOrg = async () => {
//       try {
//         const res = await axios.get(
//           `${process.env.REACT_APP_BACKEND_URL}/org-user/get-org?username=${storedUser.username}`,
//           { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
//         );
//         if (
//           res.data.subscriptionEndDate < new Date().toISOString().split("T")[0]
//         ) {
//           alert(
//             "Your organization's subscription has ended. Please contact the admin."
//           );
//           localStorage.clear();
//           navigate("/");
//           return;
//         }
//         setOrg(res.data);
//         localStorage.setItem("org", JSON.stringify(res.data.orgId));
//         localStorage.setItem("subs", JSON.stringify(res.data.subscription));
//         // Get image URL
//         if (res.data.orgLogo) {
//           const url = await viewImage(res.data.orgLogo, storedUser);
//           setFileUrl(url);
//         }
//       } catch (error) {
//         console.error("Error fetching organization:", error);
//       }
//     };
//     getOrg();
//   }, []);

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };
  
  return (
    <Box
      sx={{
        background: "#ffffff",
        borderBottom: `1px solid ${LINE}`,
        position: "sticky",
        top: 0,
        zIndex: 20,
        fontFamily: FONT,
        color: INK,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          minHeight: 56,
          px: isMobile ? 2 : 4,
          maxWidth: 1400,
          mx: "auto",
          boxSizing: "border-box",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {org && (
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              {fileUrl && (
                <img
                  src={fileUrl && fileUrl}
                  alt="Organization Logo"
                  style={{ height: 28, borderRadius: 7 }}
                />
              )}
            </div>
          )}
          <p
            style={{
              margin: 0,
              display: "inline-flex",
              alignItems: "center",
              height: 30,
              padding: "0 12px",
              borderRadius: 999,
              background: "#EFEDFB",
              border: "1px solid #D3D0F2",
              color: "#4A3FBF",
              fontFamily: FONT,
              fontSize: 13,
              fontWeight: 700,
              letterSpacing: "0.02em",
            }}
          >
            CRM
          </p>
        </div>
        <Box sx={{ display: "flex", alignItems: "center", columnGap: 2 }}>
          {!isMobile && (
            <>
              <Button
                className="btn-outlined"
                sx={{
                  height: "34px",
                  padding: "0 16px !important",
                  margin: "0 !important",
                  border: "1px solid #D5DEE7 !important",
                  borderRadius: "9px !important",
                  background: "#FFFFFF !important",
                  color: `${INK} !important`,
                  fontFamily: FONT,
                  fontSize: 13.5,
                  fontWeight: 600,
                  textTransform: "none",
                  "&:hover": { background: "#F4F7FA !important" },
                }}
                onClick={() => navigate("/partner")}
              >
                Dashboard
              </Button>
            </>
          )}
          <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1.25, fontSize: 13.5, fontWeight: 600 }}>
            {!isMobile && user && user.partnerName}
            <Avatar
              {...stringAvatar(`${user && user.partnerName}`)}
              onClick={handleAvatarClick}
              sx={{
                cursor: "pointer",
                width: 32,
                height: 32,
                bgcolor: INK,
                color: "#FFFFFF",
                fontFamily: FONT,
                fontSize: 12,
                fontWeight: 700,
                boxShadow: open ? "0 0 0 3px #D5DEE7" : "none",
                "&:hover": { boxShadow: "0 0 0 3px #E4E9EF" },
              }}
            />
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              slotProps={{
                paper: {
                  sx: {
                    mt: 1,
                    minWidth: 200,
                    borderRadius: "12px",
                    border: `1px solid ${LINE}`,
                    boxShadow: "0 16px 36px -12px rgba(15,27,42,0.24)",
                    "& .MuiList-root": { p: 0.5 },
                    "& .MuiMenuItem-root": {
                      fontFamily: FONT,
                      fontSize: 13.5,
                      borderRadius: "8px",
                      minHeight: 38,
                    },
                  },
                },
              }}
            >
              {isMobile && (
                <MenuItem onClick={() => navigate("/partner")}>
                  Dashboard
                </MenuItem>
              )}
              <MenuItem onClick={handleLogout} sx={{ color: "#A6342A", fontWeight: 600 }}>Logout</MenuItem>
            </Menu>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default PartnerNavbar;
